import { AppIcon } from '@/components/ui/app-icon';
import { companyLogoUrl } from '@/lib/company-logo-url';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { iconBuildings } from '@/lib/icons';

export const CompanyLogo: React.FC<{
  domain?: string | null;
  name?: string | null;
  className?: string;
  /** What shows when there is no logo: the building icon, or the name's first letter. */
  fallback?: 'icon' | 'initial';
}> = ({ domain, name, className, fallback = 'icon' }) => {
  const [hasError, setHasError] = useState(false);
  const logoUrl = companyLogoUrl(domain);

  const initial = name?.trim().charAt(0).toUpperCase();
  if (!logoUrl || hasError) {
    if (fallback === 'initial' && initial)
      return (
        <div
          aria-hidden
          className={cn(
            'flex h-6 w-6 items-center justify-center rounded-md bg-muted text-xs font-semibold text-muted-foreground',
            className
          )}
        >
          {initial}
        </div>
      );
    return (
      <div
        className={cn(
          'flex h-6 w-6 items-center justify-center rounded-md bg-muted',
          className
        )}
      >
        <AppIcon
          icon={iconBuildings}
          className='text-muted-foreground'
          style={{ fontSize: 14 }}
        />
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={name || 'Company logo'}
      className={cn(
        'h-6 w-6 rounded-md object-cover ring-1 ring-border/20',
        className
      )}
      onError={() => setHasError(true)}
      loading='lazy'
    />
  );
};
